import React from 'react';

import { Toolbar } from 'components';

const AchievementToolbar = ({
	selectedIds,

	handleClear
}) => (
	<Toolbar open={selectedIds?.length > 0} handleClose={handleClear}></Toolbar>
);

export default AchievementToolbar;
